import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import type { Rdo } from "../../types.ts";
import { formatRdoDate, formatRdoRevision } from "../../utils/format.ts";

interface IdentificationSectionProps {
	rdo: Rdo;
	obraName: string;
	canteiroName?: string;
	readOnly: boolean;
	onTechnicalManagerChange: (value: string) => void;
}

export function IdentificationSection({
	rdo,
	obraName,
	canteiroName,
	readOnly,
	onTechnicalManagerChange,
}: IdentificationSectionProps) {
	return (
		<section className="rdo-editor__section" aria-labelledby="rdo-identification">
			<h2 id="rdo-identification" className="rdo-editor__section-title">
				Identificação
			</h2>
			<dl className="rdo-editor__facts">
				<div>
					<dt>Obra</dt>
					<dd>{obraName}</dd>
				</div>
				{canteiroName && (
					<div>
						<dt>Canteiro</dt>
						<dd>{canteiroName}</dd>
					</div>
				)}
				<div>
					<dt>Data</dt>
					<dd>{formatRdoDate(rdo.reportDate)}</dd>
				</div>
				<div>
					<dt>Número</dt>
					<dd>
						{rdo.sequenceNumber} · {formatRdoRevision(rdo.revision)}
					</dd>
				</div>
			</dl>
			<div className="rdo-editor__field">
				<Label htmlFor="rdo-technical-manager">Responsável técnico</Label>
				<Input
					id="rdo-technical-manager"
					defaultValue={rdo.technicalManager}
					placeholder="Ex.: Eng. Maria Silva — CREA 12345"
					maxLength={200}
					disabled={readOnly}
					onChange={(event) => onTechnicalManagerChange(event.target.value)}
				/>
			</div>
		</section>
	);
}
